// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[data-v-1329e98a]{\r\n  max-width:200px;\n}\ntextarea[data-v-1329e98a]{\r\n  max-width:400px;\n}\r\n", ""]);
// Exports
module.exports = exports;
